// Curated language list for profile forms.
//
// Deliberately NOT all of ISO 639 (~7,000 entries, most irrelevant here). This
// is roughly 50 languages chosen for the markets HoopRoster actually serves:
// SEA is the beta market, Europe is next, and the import/export corridors that
// matter are Americas ↔ Europe ↔ Asia.
//
// SEA coverage is the point of the list existing, so those come first in the
// source below for reviewability — the exported array is sorted for display.
//
// Same "render an unknown stored value" rule as countries.ts: coach_languages
// is free text server-side (cap and cleaning only, no enum), so a value
// entered before this list existed must still show up rather than blanking.

const SEA_AND_ASIA = [
  'Vietnamese', 'Thai', 'Khmer', 'Lao', 'Burmese', 'Tagalog',
  'Bahasa Indonesia', 'Bahasa Malaysia', 'Mandarin', 'Cantonese',
  'Japanese', 'Korean', 'Hindi', 'Bengali', 'Urdu', 'Tamil', 'Nepali',
]

const EUROPE = [
  'English', 'French', 'Spanish', 'Portuguese', 'German', 'Italian', 'Dutch',
  'Greek', 'Turkish', 'Russian', 'Ukrainian', 'Polish', 'Czech', 'Slovak',
  'Hungarian', 'Romanian', 'Bulgarian', 'Serbian', 'Croatian', 'Bosnian',
  'Slovenian', 'Macedonian', 'Albanian', 'Lithuanian', 'Latvian', 'Estonian',
  'Finnish', 'Swedish', 'Norwegian', 'Danish', 'Icelandic', 'Georgian',
  'Armenian',
]

const OTHER = ['Arabic', 'Hebrew', 'Persian', 'Swahili', 'Afrikaans', 'Filipino']

export const LANGUAGES: readonly string[] = [
  ...new Set([...SEA_AND_ASIA, ...EUROPE, ...OTHER]),
].sort()

/**
 * Options for a language <select>, given whatever is currently stored on a
 * row. Unknown stored values are prepended rather than dropped — see the
 * header note. `coach_languages` is 0 rows everywhere today, so this matters
 * only once real data lands, but the rule is the same as countries.ts.
 */
export function languageOptions(current: string | null | undefined): readonly string[] {
  if (!current) return LANGUAGES
  const match = LANGUAGES.some((l) => l.toLowerCase() === current.toLowerCase())
  return match ? LANGUAGES : [current, ...LANGUAGES]
}
